import { graphql } from "react-relay";

export const RemoveDatadogIntegrationMutation = graphql`
  mutation RemoveDatadogIntegrationMutation {
    removeDatadogIntegration {
      datadogIntegration {
        configured
        enabled
        site
        statusInfo {
          details {
            at
            component
            message
            status
          }
          status
        }
      }
      problems {
        message
      }
    }
  }
`;
